import * as React from 'react';
import { useDispatch } from 'react-redux';

import { openOfferFromHistory } from '../../../../actions/offersHistory';
import { TThunkDispatch } from '../../../../types/redux';

export const useHandleOfferRowClick = (openFullscreenView: () => void) => {
  const dispatch = useDispatch<TThunkDispatch>();

  return React.useCallback(
    async (cianId?: number) => {
      openFullscreenView();
      await dispatch(openOfferFromHistory({ cianId }));
    },
    [dispatch, openFullscreenView],
  );
};
